import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import store from "@/store/index";
import MainLayout from "@/views/Containers/Layout/MainLayout.vue";
import Home from "@/views/Main/Home.vue";
import Users from "@/views/Main/User/Users.vue";
import CreateUser from "@/views/Main/User/CreateUser.vue";
import UpdateUser from "@/views/Main/User/UpdateUser.vue";
import ReturnedOrders from "@/views/Main/ReturnedOrders.vue";
import Products from "@/views/Main/Product/Products.vue";
import InternalProducts from "@/views/Main/InternalProduct/InternalProducts.vue";
//import InternalProductsBulkUpdate from '@/views/Main/InternalProduct/InternalProductsBulkUpdate.vue';
import UpdateInternalProduct from "@/views/Main/InternalProduct/UpdateInternalProduct.vue";
import UpdateInternalProductV2 from "@/views/Main/InternalProduct/UpdateInternalProductV2.vue";
import CreateInternalProduct from "@/views/Main/InternalProduct/CreateInternalProduct.vue";
import Series from "@/views/Main/Series/Series.vue";
import CreateSeries from "@/views/Main/Series/CreateSeries.vue";
import UpdateSeries from "@/views/Main/Series/UpdateSeries.vue";
import ProductDetail from "@/views/Main/Product/ProductDetail.vue";
import Customers from "@/views/Main/Customer/Customers.vue";
import CustomerDetail from "@/views/Main/Customer/CustomerDetail.vue";
import Domains from "@/views/Main/Domain/Domains.vue";
import Pages from "@/views/Main/Domain/Pages.vue";
//import CreateMediaPage from "@/views/Main/Domain/CreateMediaPage.vue";
import CreateMediaPage2 from "@/views/Main/Domain/CreateMediaPage2.vue";
import Detail from "@/views/Main/Order/Detail.vue";
import Actions from "@/views/Main/Actions.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/",
      redirect: "/login",
    },

    {
      path: "/dashboard",
      redirect: "/home",
      name: "Dashboard",
      component: MainLayout,
      meta: { Auth: true },
      children: [
        {
          path: "/home",
          name: "home",
          meta: {
            Auth: true,
            MenuItem: 1,
            Roles: ["*"],
          },
          component: Home,
        },
        {
          path: "/returned-orders",
          name: "returned-orders",
          meta: {
            Auth: true,
            MenuItem: 2,
            Roles: ["*"],
          },
          component: ReturnedOrders,
        },
        {
          path: "/products",
          name: "products",
          meta: {
            Auth: true,
            MenuItem: 3,
            Roles: ["*"],
          },
          component: Products,
        },
        {
          path: "/internal-products",
          name: "InternalProducts",
          meta: {
            Auth: true,
            MenuItem: 5,
            Roles: ["*"],
          },
          component: InternalProducts,
        },
        {
          path: "/internal-products/create",
          name: "CreateInternalProduct",
          meta: {
            Auth: true,
            MenuItem: 5,
            Roles: ["*"],
          },
          component: CreateInternalProduct,
        },
        {
          path: "/internal-products/:id/edit",
          name: "UpdateInternalProduct",
          meta: {
            Auth: true,
            MenuItem: 5,
            Roles: ["*"],
          },
          component: UpdateInternalProduct,
        },
        {
          path: "/internal-products-v2/:id/edit",
          name: "UpdateInternalProductV2",
          meta: {
            Auth: true,
            MenuItem: 99,
            Roles: ["*"],
          },
          component: UpdateInternalProductV2,
        },
        {
          path: "/series",
          name: "Series",
          meta: {
            Auth: true,
            MenuItem: 6,
            Roles: ["*"],
          },
          component: Series,
        },
        {
          path: "/series/create",
          name: "CreateSeries",
          meta: {
            Auth: true,
            MenuItem: 6,
            Roles: ["*"],
          },
          component: CreateSeries,
        },
        {
          path: "/series/:id/edit",
          name: "UpdateSeries",
          meta: {
            Auth: true,
            MenuItem: 6,
            Roles: ["*"],
          },
          component: UpdateSeries,
        },
        {
          path: "/products/:id/:marketplace",
          name: "productDetail",
          meta: {
            Auth: true,
            MenuItem: 5,
            Roles: ["*"],
          },
          component: ProductDetail,
        },
        {
          path: "/customers",
          name: "customers",
          meta: {
            Auth: true,
            MenuItem: 4,
            Roles: ["*"],
          },
          component: Customers,
        },
        {
          path: "/customers/:id/:marketplace",
          name: "customerDetail",
          meta: {
            Auth: true,
            MenuItem: 4,
            Roles: ["*"],
          },
          component: CustomerDetail,
        },
        {
          path: "/detail/:id",
          name: "detail",
          meta: {
            Auth: true,
            Roles: ["*"],
          },
          component: Detail,
        },
        {
          path: "/domains",
          name: "Domains",
          meta: {
            Auth: true,
            MenuItem: 7,
            Roles: ["*"],
          },
          component: Domains,
        },
        {
          path: "/domain/:id/pages",
          name: "Pages",
          meta: {
            Auth: true,
            MenuItem: 7,
            Roles: ["*"],
          },
          component: Pages,
        },
/*
        {
          path: "/page/:id/media",
          name: "CreateMediaPage",
          meta: {
            Auth: true,
            MenuItem: 7,
            Roles: ["*"],
          },
          component: CreateMediaPage,
        },
*/
        {
          path: "/page/:id/media/:smallbanner",
          name: "CreateMediaPage2",
          meta: {
            Auth: true,
            MenuItem: 7,
            Roles: ["*"],
          },
          component: CreateMediaPage2,
        },
        {
          path: "/users",
          name: "Users",
          meta: {
            Auth: true,
            MenuItem: 8,
            Roles: ["Admin", "Developer"],
          },
          component: Users,
        },
        {
          path: "/users/create",
          name: "CreateUser",
          meta: {
            Auth: true,
            MenuItem: 8,
            Roles: ["Admin", "Developer"],
          },
          component: CreateUser,
        },
        {
          path: "/users/:id/edit",
          name: "UpdateUser",
          meta: {
            Auth: true,
            MenuItem: 8,
            Roles: ["Admin", "Developer"],
          },
          component: UpdateUser,
        },
        {
          path: "/actions",
          name: "Actions",
          meta: {
            Auth: true,
            MenuItem: 9,
            Roles: ["Admin", "Developer"],
          },
          component: Actions,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.Auth && !store.state.user.isLoggedIn) {
    next({ path: "/login" });
    const wrapper = document.getElementById("content-wrapper");
    wrapper.classList.add("collapsed-content");
  } else {
    if (to.meta.hasOwnProperty("Roles")) {
      if (
        !(
          to.meta.Roles.includes(store.state.user.userRole) ||
          to.meta.Roles.includes("*")
        )
      ) {
        next({ path: "/login" });
      }
    }
    next();
  }
});

export default router;
